export default __webpack_public_path__ + "static/media/PAFI_Minutes Summary of GMS of June 24, 2024.86d22b71.pdf";